import Mutations from '../../odata/mutations';

export default { ...new Mutations('revenueLine'), ...new Mutations('revenueLines') };
